module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-react-i18next/gatsby-browser.js'),
      options: {"plugins":[],"localeJsonSourceName":"locales","languages":["ar","en"],"defaultLanguage":"ar","generateDefaultLanguagePage":true,"siteUrl":"https://kisoft.me","i18nextOptions":{"interpolation":{"escapeValue":false},"keySeparator":".","nsSeparator":false}},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Kisoft","short_name":"Kisoft","start_url":"/","background_color":"#0938b5","theme_color":"#0249ff","display":"minimal-ui","icon":"src/images/our_logos/tab_logo.svg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"ae4e8eba60a74c58dc5ded2863d3c288"},
    },{
      plugin: require('../node_modules/gatsby-plugin-matomo/gatsby-browser.js'),
      options: {"plugins":[],"siteId":"2","matomoUrl":"https://um.kisoft.me","siteUrl":"https://kisoft.me","matomoPhpScript":"matomo.php","matomoJsScript":"matomo.js","trackPageView":true,"requireConsent":false,"localScript":false,"dev":false},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
